import { apiRequest } from '@/shared/api/http'
import type { Branch, CreateBranchPayload, UpdateBranchPayload } from '@/features/branches/domain/branch.types'

// Branches are the scope itself — this resource is never branch-scoped and takes no branchId.
const BRANCHES_ENDPOINT = '/v1/branches'

export const branchesApi = {
  list: (signal?: AbortSignal) =>
    apiRequest<Branch[]>(BRANCHES_ENDPOINT, {
      method: 'GET',
      signal,
    }),

  getById: (id: number | string, signal?: AbortSignal) =>
    apiRequest<Branch>(`${BRANCHES_ENDPOINT}/${id}`, {
      method: 'GET',
      signal,
    }),

  create: (payload: CreateBranchPayload, signal?: AbortSignal) =>
    apiRequest<Branch>(BRANCHES_ENDPOINT, {
      method: 'POST',
      body: payload,
      signal,
    }),

  // PUT, unlike every other resource here: PATCH /branches/{id} answers 405 (hatchery.md §3).
  update: (id: number | string, payload: UpdateBranchPayload, signal?: AbortSignal) =>
    apiRequest<Branch>(`${BRANCHES_ENDPOINT}/${id}`, {
      method: 'PUT',
      body: payload,
      signal,
    }),

  delete: (id: number | string, signal?: AbortSignal) =>
    apiRequest<void>(`${BRANCHES_ENDPOINT}/${id}`, {
      method: 'DELETE',
      signal,
    }),
}
